import React, { ReactElement, SyntheticEvent } from 'react';
import { CSSObject } from 'styled-components';
import { SpaceProps, LayoutProps, FlexboxProps } from 'styled-system';

import { FormGroup } from '../index';

import { Select, FormLabel, StyledFormFeedback } from 'ui/components';

type ssProps = SpaceProps & LayoutProps & FlexboxProps;

export type OptionItem = {
  id: number;
  name: string;
};

export type SelectProps = ssProps & {
  name?: string;
  label?: string;
  value?: number | string;
  onTextChange?: (text: string) => void;
  type?: 'email' | 'number' | 'password' | 'search' | 'text' | 'tel' | 'url';
  placeholder?: string;
  disabled?: boolean;
  validation?: 'error' | 'success' | 'warning';
  feedback?: string;
  required?: boolean;
  options?: Array<OptionItem>;
  register?: ({ required }: { required?: boolean }) => RefReturn;
  onChange?: (e: SyntheticEvent<HTMLSelectElement>) => void;
  noSelectOption?: boolean;
  style?: CSSObject;
};

type item = string;

type RefReturn =
  | string
  | ((instance: HTMLSelectElement | null) => void)
  | React.RefObject<HTMLSelectElement>
  | null
  | undefined;

const FormSelect = ({
  name,
  label,
  value,
  placeholder,
  disabled,
  validation,
  feedback,
  required,
  options,
  register,
  onChange,
  noSelectOption,
  style,
  ...ssProps
}: SelectProps): ReactElement => {
  const id = `toggle-${label ? label.replace(/ /g, '').toLowerCase() : null}`;
  return (
    <FormGroup style={style} {...ssProps}>
      {label ? (
        <FormLabel htmlFor={id} required={required}>
          {label}
        </FormLabel>
      ) : null}
      <Select
        name={name || label}
        register={register}
        placeholder={placeholder}
        value={value}
        id={id}
        disabled={disabled}
        validation={validation}
        options={options}
        onChange={onChange}
        noSelectOption={noSelectOption}
      />
      {feedback ? (
        <StyledFormFeedback validation={validation}>
          {feedback}
        </StyledFormFeedback>
      ) : null}
    </FormGroup>
  );
};

export { FormSelect };
